import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from '@/components/buttons/Button';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import CloseButton from '@/components/UI/Buttons/CloseButton';
import { useCashierHide, useDepositTabEffect } from '@/features/cashier/useCashier';
import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import { useFluidClose } from '@/features/cashier/fluid/fluidPaymentsStore';
import { setFtdExitIntentShown } from '@/store/modal/actions';
import Logo from '@/components/shared/logos/Logo';
import { selectExitIntentOffer } from '@/store/cms/welcome-texts/selectors';
import { BaseModalProps } from '@/features/modal/types';

export const ExitIntentModal = ({ closeModal }: BaseModalProps) => {
  const intl = useIntl();
  const navigate = useAbsoluteNavigate();
  const hideCashier = useCashierHide();
  const { toggleDepositTabEffectTrigger } = useDepositTabEffect();
  const closeFluid = useFluidClose();
  const dispatch = useDispatch();
  const exitIntentOffer = useSelector(selectExitIntentOffer);

  const handleOnClose = () => {
    closeModal();
    hideCashier();
    closeFluid();
    triggerGTag(GTagEvents.ftd_exit_intent_closed);
  };

  const handleOnDeposit = () => {
    toggleDepositTabEffectTrigger();
    closeModal();
    triggerGTag(GTagEvents.ftd_exit_intent_deposit);
  };

  const handleOnGamesRedirect = () => {
    closeModal();
    hideCashier();
    closeFluid();
    triggerGTag(GTagEvents.ftd_exit_intent_closed);
    navigate('/games');
  };

  useEffect(() => {
    dispatch(setFtdExitIntentShown());
  }, []);

  return (
    <div
      className="transition-all ease-in-out duration-1000 w-[350px] rounded-lg bg-slate-50"
      data-cy="exit-intent"
    >
      <div className="flex flex-col items-center space-y-[48px] justify-center relative p-8">
        <CloseButton left onClick={handleOnClose} />
        <Logo color="blue3" />
        <div className="text-2xl font-bold">{intl.formatMessage({ id: 'exitIntent.header' })}</div>
        <div className="text-lg font-extralight text-center">
          <div className="[&_p]:m-0 [&_p]:p-0 [&_strong]:text-blue-light">{exitIntentOffer}</div>
        </div>
        <div className="flex flex-col items-center space-y-[16px] w-[200px]">
          <Button
            onClickHandler={handleOnDeposit}
            btnType="primary"
            text={intl.formatMessage({ id: 'notifications.lowBalanceCta' })}
          />
          <button
            type="button"
            className="rounded-full w-full trensition ring-[3px] ring-blue-light ring-inset p-3 text-blue-light hover:border-cyan-600 hover:text-blue-light font-bold"
            onClick={handleOnGamesRedirect}
          >
            {intl.formatMessage({ id: 'home.games.seeAllGames' })}
          </button>
        </div>
      </div>
    </div>
  );
};
